module.exports = __webpack_public_path__ + "static/sponsorship_img-03-b-31f73d9ef6de22bfbc83f560c8376a85.jpg";